var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0352 1H3.96454C2.3273 1 1 2.32725 1 3.96454V20.0353C1 21.6726 2.32725 22.9999 3.96454 22.9999H11.8905L11.904 15.1383H9.86161C9.59618 15.1383 9.38075 14.9237 9.37973 14.6583L9.36993 12.1242C9.36891 11.8573 9.58499 11.6404 9.85187 11.6404H11.8906V9.1918C11.8906 6.35023 13.626 4.80297 16.1609 4.80297H18.241C18.5071 4.80297 18.7229 5.01872 18.7229 5.28491V7.42168C18.7229 7.68775 18.5073 7.90346 18.2412 7.90362L16.9647 7.90421C15.5862 7.90421 15.3193 8.55928 15.3193 9.52062V11.6404H18.3484C18.637 11.6404 18.8609 11.8925 18.8269 12.1791L18.5266 14.7132C18.4978 14.9557 18.2922 15.1384 18.048 15.1384H15.3328L15.3193 23H20.0353C21.6726 23 22.9998 21.6728 22.9998 20.0355V3.96454C22.9998 2.32725 21.6725 1 20.0352 1Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.69bb2c8365b21222efc164875edc65da.svg";
export { ForwardRef as ReactComponent };